import { Divider } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PaymentProps } from 'src/common/api/response';
import { amountFormat } from 'src/common/utils/AmountFormat';
import { CardContainer, Container, LabelValueRow, RegularText, SizedBox } from 'src/components';
import { metrics } from 'src/themes/Metrics';

export const PaymentBreakdownCard = ({
  payment,
  // reservation,
  isReturnTrip,
}: {
  payment?: PaymentProps;
  // reservation: ReservationProps;
  isReturnTrip: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <CardContainer>
      <RegularText fontWeight="bold" fontSize="large">
        {t('paymentBreakdown')}
      </RegularText>
      <SizedBox height="medium" />
      {isReturnTrip ? (
        <LabelValueRow fontSize="large" label="returnTrip" value={amountFormat(payment?.returnTotal)} />
      ) : (
        <LabelValueRow fontSize="large" label="departureTrip" value={amountFormat(payment?.departureTotal)} />
      )}
      {payment?.couponDiscount ? (
        <LabelValueRow fontSize="large" label="discount" value={amountFormat(payment?.couponDiscount)} />
      ) : (
        <Container />
      )}
      {payment?.coupon ? <LabelValueRow fontSize="large" label="couponUsed" value={payment.coupon} /> : <Container />}
      <Container marginVertical={metrics.medium}>
        <Divider />
      </Container>
      <LabelValueRow
        fontSizeValue="larger"
        fontWeightValue="bold"
        fontSizeLabel="large"
        label="total"
        value={amountFormat(payment?.total)}
      />
    </CardContainer>
  );
};
